import HomeComponent from './home.component';

angular
	.module('app.home', [])
	.component('home', HomeComponent);
